module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAP1BMVEUAAAD3fyj3gCj4fyj2fyn2gCn3fyf/gCD3fyj6gSj3fyj3gCj2gCfvgCD4fyn3gCn3gCb4gCj3fyj3gCj3fygK5Ui3AAAAFHRSTlMA3yCA7zDQEKBfj2BwEO+vUL+/QABXiAwAAACpSURBVEjH7dRJDsMgEERRpmYyiZ2k73/WhD5ClSUHybV/EkJ83L0r11KKMPaqCuukv3UQi+lK6VwwHbzpwGi/oH5k0wLqfeonqF3VuQbqaHpQOi6oN2UiO06I7M1FVtbL5IzIMnrn1hhz7kHYCFlhbMJtMzswq3MbXnQ6CCu49ZjtxJOuuC07YTP+gQSzr4KnUImMOmYvyugDWT6jQFgneEZWUhZ37//2BeJwEfWHyQQlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/resource/down.png
// module id = wuRf
// module chunks = 1